// todo: replace with fe-core/DataStore
import { CachedFilter } from 'redux/ducks/reportFilter/index';

export default class Cache {
  private cachingEnabled = window.hasOwnProperty('localStorage');
  private localStorageKey = 'fw_new_reports_filter_cache';
  private store = {
    reportsPaths: {} as { [cacheKey: string]: CachedFilter }
  };

  constructor(disableCache?: boolean) {
    this.cachingEnabled = !disableCache && this.cachingEnabled;
    if (this.cachingEnabled && window.localStorage.getItem(this.localStorageKey)) {
      try {
        // eslint-disable-next-line
        this.store = Object.assign(
          this.store,
          JSON.parse(window.localStorage.getItem(this.localStorageKey))
        );
        // temp. pre-plan bw-compat fix, add _professional to key of existing keys,
        // existing users are all professional plan users
        Object.keys(this.store.reportsPaths).forEach((cacheKey) => {
          if (!cacheKey.includes('_')) {
            this.store.reportsPaths[`${cacheKey}_professional`] = this.store.reportsPaths[cacheKey];
            delete this.store.reportsPaths[cacheKey];
          }
        });
      } catch (e) {
        console.error(e);
      }
    }
  }

  public getIsCachingEnabled(): boolean {
    return this.cachingEnabled;
  }

  public persistReportsPath(cacheKey: string, data: CachedFilter): void {
    if (!this.getIsCachingEnabled()) {
      return;
    }

    if (!data) {
      delete this.store.reportsPaths[cacheKey];
    } else {
      this.store.reportsPaths[cacheKey] = data;
    }
    this.persistStore();
  }

  public getReportsPath(cacheKey: string): CachedFilter | null {
    return this.store.reportsPaths.hasOwnProperty(cacheKey)
      ? this.store.reportsPaths[cacheKey]
      : null;
  }

  public remove(cacheKey: string): void {
    delete this.store.reportsPaths[cacheKey];
    this.persistStore();
  }

  public persistStore() {
    window.localStorage.setItem(this.localStorageKey, JSON.stringify(this.store));
  }
}
